<mat-card>
  <mat-card-content>
    <mat-card-title>
      Presidenti

    
      <div fxFlex="70%;" fxFlex.xs="100%" align="right">
        <button mat-raised-button
                color="primary" (click)="btnAggiungiModifica(-1)">
          Nuovo
        </button>
      </div>

      <div fxFlex="25%;" fxFlex.xs="100%" align="right">
        <button mat-raised-button color="primary">
          <a style="color:white" csvLink delimiter=";" [data]="lstElenco" filename="Presidenti">Esporta CSV</a>
        </button>
      </div> 

    </mat-card-title>
  </mat-card-content>
</mat-card>

<mat-card>
  <mat-card-content>

    <div fxLayout="row wrap">
      <div fxFlex.gt-sm="50%">
        <mat-form-field class="full-width">
          <input matInput
                 placeholder="Filtra"
                 [(ngModel)]="txtFiltra"
                 id="txtFiltra"
                 value=""
                 (keyup)='updateFilter($event)'>
        </mat-form-field>
      </div>
    </div>

    <ngx-datatable #grdPresidenti
                   [rows]="lstElenco"
                   [columnMode]="'flex'"
                   [headerHeight]="50"
                   [footerHeight]="50"
                   [limit]="30"
                   [rowHeight]="'auto'">
     
  <ngx-datatable-column name="" [flexGrow]="0.5">
    <ng-template let-row="row" ngx-datatable-cell-template>
      <div style="float:left">
        <button mat-icon-button mat-sm-button color="primary"
                class="mr-1"
                (click)="btnAggiungiModifica(row.idPresidente)"
                matTooltip="Modifica">
          <mat-icon>edit</mat-icon>
        </button>
      </div>
    </ng-template>
  </ngx-datatable-column>

      <ngx-datatable-column name="Cognome Nome"
                            [flexGrow]="3"
                            [sortable]="true"
                            prop="CognomeNome">
        <ng-template let-row="row" ngx-datatable-cell-template>
          {{ row?.CognomeNome }}
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column name="Validità dal"
                            [flexGrow]="1"
                            [sortable]="true"
                            prop="ValiditaDal">
        <ng-template let-row="row" ngx-datatable-cell-template>
          {{ row?.ValiditaDal | date: 'dd/MM/yyyy'}}
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column name="Validità al"
                            [flexGrow]="1"
                            [sortable]="true"
                            prop="ValiditaAl">
        <ng-template let-row="row" ngx-datatable-cell-template>
          {{ row?.ValiditaAl | date: 'dd/MM/yyyy'}}
        </ng-template>
      </ngx-datatable-column>

    </ngx-datatable>

  </mat-card-content>
</mat-card>


